import { useState } from "react";

import Button from "@mui/material/Button";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import VideocamIcon from "@mui/icons-material/Videocam";
import PhotoIcon from "@mui/icons-material/Photo";
import HideImageIcon from "@mui/icons-material/HideImage";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import CommentIcon from "@mui/icons-material/Comment";
import CommentsDisabledIcon from "@mui/icons-material/CommentsDisabled";
import CallEndIcon from "@mui/icons-material/CallEnd";
import ModalImagenes from "./ModalImagenes";

const Controls = ({ tracks, setStart, setInCall, useClient, message, setMessage, funcionFondo, desactivarFondo, virtualBackgroundEnabled }) => {
  const client = useClient();
  const [trackState, setTrackState] = useState({ video: true, audio: true });
  const [modalImagenes, setModalImagenes] = useState(false);

  const mute = async (type) => {
    if (type === "audio") {
      await tracks[0].setEnabled(!trackState.audio);
      // await tracks[0].setMuted(!trackState.audio);
      setTrackState((ps) => ({ ...ps, audio: !ps.audio }));
    } else if (type === "video") {
      await tracks[1].setEnabled(!trackState.video);
      setTrackState((ps) => ({ ...ps, video: !ps.video }));
    }
  };

  const leaveChannel = async () => {
    await client.leave();
    client.removeAllListeners();
    tracks[0].close();
    tracks[1].close();
    setStart(false);
    setInCall(false);
  };

  const controlButtonStyle = (property) => {
    const style = {
      minWidth: "60px",
      minHeight: "60px",
      borderRadius: "50%",
      fontSize: "24px",
      boxSizing: "border-box",
      overflow: "hidden",
      color: "white",
    };
    if (property) {
      return {
        ...style,
        backgroundColor: trackState[property] ? "#5d9af5" : "#f5675d",
      };
    } else {
      return {
        ...style,
        backgroundColor: "#5d9af5",
      };
    }
  };

  const aplicarFondo = () => {
    setModalImagenes(true);
  };

  return (
    <>
      <div
        className={message ? "controls-container" : ""}
        style={{
          position: "absolute",
          bottom: "20px",
          display: "flex",
          // width: "70%",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className={message ? "controls-container-1" : ""} style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
          <Button className={message ? "button-hidden" : ""} style={controlButtonStyle("audio")} onClick={() => mute("audio")}>
            {trackState.audio ? <MicIcon fontSize="inherit" /> : <MicOffIcon fontSize="inherit" />}
          </Button>
          <Button className={message ? "button-hidden" : ""} style={controlButtonStyle("video")} onClick={() => mute("video")}>
            {trackState.video ? <VideocamIcon fontSize="inherit" /> : <VideocamOffIcon fontSize="inherit" />}
          </Button>
          <Button className={message ? "button-hidden" : ""} style={controlButtonStyle("video")} onClick={() => aplicarFondo()}>
            {!virtualBackgroundEnabled ? <PhotoIcon fontSize="inherit" /> : <HideImageIcon fontSize="inherit" />}
          </Button>
          <Button style={controlButtonStyle()} onClick={() => setMessage(!message)}>
            {!message ? <CommentIcon fontSize="inherit" /> : <CommentsDisabledIcon fontSize="inherit" />}
          </Button>
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          top: "20px",
          right: message ? "520px" : "20px",
        }}
      >
        <Button
          style={{
            backgroundColor: "#f5675d",
            // width: "60px",
            // height: "60px",
            borderRadius: "20px",
            fontSize: "32px",
            color: "white",
            border: "none",
          }}
          onClick={() => leaveChannel()}
        >
          <CallEndIcon fontSize="inherit" />
        </Button>
      </div>
      {modalImagenes && (
        <ModalImagenes
          virtualBackgroundEnabled={virtualBackgroundEnabled}
          desactivarFondo={desactivarFondo}
          modalImagenes={modalImagenes}
          funcionFondo={funcionFondo}
          setModalImagenes={setModalImagenes}
        />
      )}
    </>
  );
};

export default Controls;
